/* ════════════════════════════════════════════════════════════════════════
   PRODUCT NUTRITION MOCK DATA — sample NZ household pantry items for the
   barcode/QR scanner demo. **Mock product data for demo only.** No real
   product database access — for planning estimates only.

   Schema:
     barcode            — string (EAN-13 / UPC-12 style)
     productName        — string
     brand              — string
     servingSize        — number (in servingUnit)
     servingUnit        — "g" | "ml" | "slice" | "egg" | "tbsp"
     nutritionPerServe  — { calories, protein, carbs, fat }
     nutritionPer100g   — optional { calories, protein, carbs, fat }
     ingredients        — optional string[]
     allergens          — optional string[]
     imageUrl           — optional string
     source             — "mock-local"
   ════════════════════════════════════════════════════════════════════════ */

export const MOCK_PRODUCTS = [
  {
    barcode: "9415137001157",
    productName: "Anchor Blue Top Milk",
    brand: "Anchor",
    servingSize: 250, servingUnit: "ml",
    nutritionPerServe:  { calories: 165, protein: 8.4, carbs: 12, fat: 8.5 },
    nutritionPer100g:   { calories: 66,  protein: 3.4, carbs: 4.8, fat: 3.4 },
    allergens: ["Milk"], source: "mock-local",
  },
  {
    barcode: "9300601003078",
    productName: "Yoplait Greek Style Natural Yoghurt",
    brand: "Yoplait", servingSize: 150, servingUnit: "g",
    nutritionPerServe:  { calories: 138, protein: 14.4, carbs: 9.6, fat: 4.5 },
    nutritionPer100g:   { calories: 92,  protein: 9.6,  carbs: 6.4, fat: 3.0 },
    allergens: ["Milk"], source: "mock-local",
  },
  {
    barcode: "9415137100065",
    productName: "Anchor Pure Butter (Salted)",
    brand: "Anchor", servingSize: 10, servingUnit: "g",
    nutritionPerServe:  { calories: 73, protein: 0.1, carbs: 0,   fat: 8.1 },
    nutritionPer100g:   { calories: 730, protein: 0.6, carbs: 0,  fat: 81 },
    allergens: ["Milk"], source: "mock-local",
  },
  {
    barcode: "9415004102337",
    productName: "Mainland Tasty Cheese",
    brand: "Mainland", servingSize: 30, servingUnit: "g",
    nutritionPerServe:  { calories: 124, protein: 7.8, carbs: 0.3, fat: 10.2 },
    nutritionPer100g:   { calories: 413, protein: 26,  carbs: 1.0, fat: 34 },
    allergens: ["Milk"], source: "mock-local",
  },
  {
    barcode: "9300675020442",
    productName: "Uncle Tobys Rolled Oats",
    brand: "Uncle Tobys", servingSize: 45, servingUnit: "g",
    nutritionPerServe:  { calories: 158, protein: 5.8, carbs: 25,  fat: 3.0 },
    nutritionPer100g:   { calories: 350, protein: 13,  carbs: 56,  fat: 6.7 },
    ingredients: ["Wholegrain rolled oats"], allergens: ["Gluten", "May contain traces of nuts"], source: "mock-local",
  },
  {
    barcode: "9415077621101",
    productName: "SunRice White Long Grain Rice",
    brand: "SunRice", servingSize: 75, servingUnit: "g",
    nutritionPerServe:  { calories: 270, protein: 5.2, carbs: 60,  fat: 0.5 },
    nutritionPer100g:   { calories: 360, protein: 7.0, carbs: 80,  fat: 0.7 },
    source: "mock-local",
  },
  {
    barcode: "9300675034975",
    productName: "San Remo Spaghetti No.5",
    brand: "San Remo", servingSize: 100, servingUnit: "g",
    nutritionPerServe:  { calories: 340, protein: 12,  carbs: 70,  fat: 1.5 },
    allergens: ["Gluten"], source: "mock-local",
  },
  {
    barcode: "9421902005082",
    productName: "Vogel's Original Sourdough Bread",
    brand: "Vogel's", servingSize: 1, servingUnit: "slice",
    nutritionPerServe:  { calories: 115, protein: 5.4, carbs: 18,  fat: 1.5 },
    allergens: ["Gluten", "Soy"], source: "mock-local",
  },
  {
    barcode: "9415077000040",
    productName: "Free Range Eggs Size 7 (each)",
    brand: "Mainland Farms", servingSize: 1, servingUnit: "egg",
    nutritionPerServe:  { calories: 78, protein: 6.5, carbs: 0.4, fat: 5.3 },
    allergens: ["Egg"], source: "mock-local",
  },
  {
    barcode: "9421021601021",
    productName: "Healtheries Whey Protein Powder Vanilla",
    brand: "Healtheries", servingSize: 30, servingUnit: "g",
    nutritionPerServe:  { calories: 113, protein: 24,  carbs: 2.4, fat: 0.9 },
    allergens: ["Milk", "Soy"], source: "mock-local",
  },
  {
    barcode: "8076800195057",
    productName: "Watties Diced Tomatoes in Juice",
    brand: "Watties", servingSize: 100, servingUnit: "g",
    nutritionPerServe:  { calories: 25, protein: 1.2, carbs: 4.0, fat: 0.2 },
    source: "mock-local",
  },
  {
    barcode: "8000500001059",
    productName: "Dolmio Original Pasta Sauce",
    brand: "Dolmio", servingSize: 125, servingUnit: "g",
    nutritionPerServe:  { calories: 65, protein: 1.9, carbs: 12,  fat: 1.0 },
    nutritionPer100g:   { calories: 52, protein: 1.5, carbs: 9.4, fat: 0.8 },
    source: "mock-local",
  },
  {
    barcode: "9415077823100",
    productName: "Pic's Smooth Peanut Butter",
    brand: "Pic's", servingSize: 20, servingUnit: "g",
    nutritionPerServe:  { calories: 121, protein: 5.4, carbs: 2.4, fat: 9.8 },
    allergens: ["Peanuts"], source: "mock-local",
  },
  {
    barcode: "9415000130145",
    productName: "Ceres Organics Tahini",
    brand: "Ceres", servingSize: 15, servingUnit: "g",
    nutritionPerServe:  { calories: 90, protein: 2.8, carbs: 0.6, fat: 8.4 },
    allergens: ["Sesame"], source: "mock-local",
  },
  {
    barcode: "9418863000045",
    productName: "Urban Hippie Miso Paste",
    brand: "Urban Hippie", servingSize: 18, servingUnit: "g",
    nutritionPerServe:  { calories: 35, protein: 2.2, carbs: 4.5, fat: 1.1 },
    allergens: ["Soy"], source: "mock-local",
  },
  {
    barcode: "9419023400218",
    productName: "Ceres Organic Coconut Milk",
    brand: "Ceres", servingSize: 100, servingUnit: "ml",
    nutritionPerServe:  { calories: 190, protein: 1.9, carbs: 2.9, fat: 19 },
    source: "mock-local",
  },
  {
    barcode: "9415137005612",
    productName: "Olivado Extra Virgin Olive Oil",
    brand: "Olivado", servingSize: 14, servingUnit: "ml",
    nutritionPerServe:  { calories: 124, protein: 0, carbs: 0, fat: 14 },
    source: "mock-local",
  },
  {
    barcode: "9415004001033",
    productName: "Edmonds Standard Flour",
    brand: "Edmonds", servingSize: 30, servingUnit: "g",
    nutritionPerServe:  { calories: 109, protein: 3.0, carbs: 22,  fat: 0.3 },
    allergens: ["Gluten"], source: "mock-local",
  },
  {
    barcode: "9415137009290",
    productName: "Chelsea White Sugar",
    brand: "Chelsea", servingSize: 5, servingUnit: "g",
    nutritionPerServe:  { calories: 20, protein: 0, carbs: 5, fat: 0 },
    source: "mock-local",
  },
];

/* Map barcode → product for O(1) lookup. */
export const PRODUCT_BARCODE_INDEX = MOCK_PRODUCTS.reduce((acc, p) => {
  acc[p.barcode] = p;
  return acc;
}, {});

export const MOCK_DATA_NOTICE = "Mock product data for demo only.";
